import store from '../store'
import Request from './request'
import i18n from "@/i18n";
import snackbar from "@/plugins/snackbar";


async function fetch(id,data){
    return Request("get","api/stock-outs?supplier_id=" + id,data)
}

async function fetchOne(id,data){
    return Request("get","api/stock-outs/" + id, data)
}

async function exports(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get','api/stock-outs/supplier-refund-stock-out-export',data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop");
    return response
}

async function exportOne(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('get','api/stock-outs/supplier-refund-stock-out-detail-export?id=' + id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop");
    return response
}

export default {
    fetch,
    fetchOne,
    exports,
    exportOne
}